'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (palette) {
    return {
        display: 'block',
        padding: palette.gutter + 'px ' + palette.gutter * 5 + 'px ' + palette.gutter + 'px ' + palette.gutter + 'px',
        background: palette.elPrimary,
        border: '1px solid ' + palette.elPrimary,
        boxShadow: '0 8px 12px 0 ' + palette.elShadow + ', 0 6px 12px 0 ' + palette.elShadow,
        zIndex: palette.zOverlay,
        color: palette.tError,
        closeIcon: _closeIcon2.default,
        width: 'auto',
        minWidth: 'auto',
        maxWidth: 'auto',
        borderRadius: '2px',
        textAlign: 'left'
    };
};

var _closeIcon = require('../img/closeIcon.svg');

var _closeIcon2 = _interopRequireDefault(_closeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }